module.exports = __webpack_public_path__ + "static/media/Screen_Shot_2564-05-21_at_23.36.12.8ed26835.png";